import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { ConstantsService } from "../../services/constants/constants.service";

@Component({
  selector: 'app-questionnaire-limit-modal',
  templateUrl: './questionnaire-limit-modal.component.pug',
  styleUrls: ['./questionnaire-limit-modal.component.scss'],
  standalone: false
})
export class QuestionnaireLimitModalComponent extends AbstractModalComponent implements OnInit {

  @Input() questionnaire_limit!: any;
  @Input() model!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;
  QUESTIONNAIRE_LIMIT = ConstantsService.QUESTIONNAIRE_LIMIT;
  PULSE_QUESTIONNAIRE_LIMIT: number[] = [];
  exitLimitLabel :string = '';
  pulseLimitLabel :string = '';
  pulseLimitOptions: Array<{key: string, value: string}> = [];
  exitLimitOptions: Array<{key: string, value: string}> = [];

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = this.model == 'exit' 
      ? { 'questionnaire_limit': this.questionnaire_limit } 
      : { 'pulse_questionnaire_limit': this.questionnaire_limit };

    this.PULSE_QUESTIONNAIRE_LIMIT = ConstantsService.PULSE_QUESTIONNAIRE_LIMIT;

    if (this.model === 'exit') {
      this.exitLimitOptions = this.convertToDropdownOptions(this.QUESTIONNAIRE_LIMIT);
      this.exitLimitLabel = this.orgDetails.questionnaire_limit?.toString() ?? '';
    }

    if (this.model === 'pulse') {
      this.pulseLimitOptions = this.convertToDropdownOptions(this.PULSE_QUESTIONNAIRE_LIMIT);
      this.pulseLimitLabel = this.orgDetails.pulse_questionnaire_limit?.toString() ?? '';
    }
  }

  private convertToDropdownOptions(limits: number[]): Array<{key: string, value: string}> {
    return limits.map(limit => ({
      key: limit.toString(),
      value: limit.toString()
    }));
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    
    if (this.model === 'exit') {
      const isValid = !!this.orgDetails.questionnaire_limit;
      if (!isValid) return;
    } else if (this.model === 'pulse') {
      const isValid = !!this.orgDetails.pulse_questionnaire_limit;
      if (!isValid) return;
    }
    
    this.event.emit(this.orgDetails);
  }

  onExitLimitChange(event: {key: string, value: string}): void {
    this.orgDetails.questionnaire_limit = parseInt(event.value, 10);
    this.exitLimitLabel = event.value;
  }

  onPulseLimitChange(event: {key: string, value: string}): void {
    this.orgDetails.pulse_questionnaire_limit = parseInt(event.value, 10);
    this.pulseLimitLabel = event.value;
  }

  getForm() {
    return this.orgForm;
  }

}
